export default "__VITE_ASSET__DAiO1bNg__"